/*
Sohel 11/09/2022 2700430604 Added Filter based on Field List Code
Sohel 11/14/2022 2700430604 pass actions
Sohel 11/14/2022 2700430604 Save API Payload Changes
Ravi 2700430604 Added stepper tabs  toast messages
akhila 11/24/2022 2700430604 fixed  Expand the expression's
ashraf 11/24/2022 2700430604 fixed default expansion of accordion
akhila 11/26/2022 2700430604 passed overrideType in payload
dilip 12/1/2022 2700430604  default expansion of accordion

Sohel 12/01/2022 2700430604 Added Override Type in payload.
Sai Maheshwar 12/03/2022 2701135832 added AND/OR conditions
Saikrishna 12/09/2022 2701135832 save and stay in page functionality added.
Sohel 12/13/2022 2701135832 conditionally hide Save Button
Akhila 12/15/2022 2701135832 Added Role based access
Sohel 12/16/2022 2701135832  Add Filter Search Table Changes
Raghu 12/17/2022 2701135832 Button spacing fixes
Ashraf 12/20/2022 2701135832 fixed user role access
sai Krishna 12/23/2022 2701135832 added Triggercode  and Trigger description
Saikrishna 01/05/2023 2701135832 change the filter download toaster message
Lalitha 01/10/2023 2701135832  fixed download configuration issue
Akhila 01/20/2023 2701135832 unsaved chnages alert popup issue fixed
Sohel 02/16/2023 2701135832 Trigger Maintenance Payload Changes
Raghu 02/22/2023 2701135832 new UI buttons changes
Dilip 02/22/2023 2700430604 added download usage configuration
Raghu 03/01/2023 2700430604 fixed buttons
Sohel 03/13/2023 2700430604 Added Last Step in payload
Sohel 03/13/2023 2700430604 Added Last Step in payload
Sohel 03/15/2023 2700430604 condition changes
Akhila 05/31/2023 2700430604 unsaved changes bug fixed
Ravi 06/19/2023 2700430604 Added Breadcrum in popup
Akhila 06/21/2023 2700430604 conditionally disable save and finish button on submission
*/
import React, {useState, useEffect, useRef} from 'react';
import {Button, makeStyles, Typography} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import AddFilterRuleGroup from '../../BRE/FilterRuleGroup/AddFilterRuleGroup';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import FilterTable from '../../BRE/FilterRuleGroup/SearchRuleGroup';
import FilterInformationTable from '../../ReportMaster/AddReportMaster/StepperComponents/Filter/FilterInformationTable';
import {useSelector, useDispatch} from 'react-redux';
import reusableInputStyles from '../../../../components/InputStyles';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import {
  fetchEventTactic,
  postEventTactic,
  ResetMessage as resetMessage,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import {fetchFilterRuleGroup} from '../../../../redux/reducers/BRE/AddRuleGroup';
import BreadCrums from '../../../../util/BreadCrum';
import {resetPrintUsageData} from '../../../../redux/reducers/printUsage';
import {setAlertData} from '../../../../redux/reducers/UnsavedChangesAlertReducer';
import {submissionStart} from '../../../../redux/reducers/CommonActions/commonActions';
const useStyles = makeStyles((theme) => ({
  goBackBtn: {
    padding: '6px 12px',
    color: '#320469',
    marginBottom: '10px',
  },
  root: {
    'width': '100%',
    'backgroundColor': '#fff',
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    'marginTop': '10px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#f3f3f3',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },
}));

const StepperFilter = ({
  fieldListCode,
  handleBack,
  handleNext,
  activeStep,
  steps,
  stepSuccessMsg,
  setStepSuccessMsg,
  overrideType,
  rowSelected,
  handleDirty,
  showAlertRef,
}) => {
  const componentClasses = useStyles();
  const classes = reusableInputStyles();
  const [ShowFilterData, setShowFilterData] = useState(false);
  const {filterRuleGroupData} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {
    addEventTacticStatus,
    eventTacticData,
    errorMsg,
    successMsg,
    isLoading,
    triggerId,
    downloadSuccessMsg,
  } = useSelector(({addEventTactic}) => addEventTactic);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const [ruleGroupId, setRuleGroupId] = useState('');
  const [ruleGroupCode, setRuleGroupCode] = useState('');
  const [groupId, setGroupId] = useState('');
  const [expanded, setExpanded] = useState(true);
  const [isCopy, setIsCopy] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const roleDataDisable = roleData?.window?.['Triggers Maintenance']?.TM;
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  const saveRef = useRef();
  const [formulaRuleId, setFormulaRuleId] = useState(
    eventTacticData?.ruleGroupId ? eventTacticData?.ruleGroupId : 0,
  );
  const dispatch = useDispatch();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    setFormulaRuleId(eventTacticData?.ruleGroupId ? eventTacticData?.ruleGroupId : 0);
  }, [ruleGroupCode]);
  const handleSubmit = () => {
    dispatch(submissionStart());
    const passValues = {
      code: eventTacticData?.code ? eventTacticData?.code : triggerId,
      id: eventTacticData?.id ? eventTacticData?.id : 0,
      description: eventTacticData?.description ? eventTacticData?.description : '',
      mode: eventTacticData?.mode ? eventTacticData?.mode : '',
      ruleGroupCode: ruleGroupCode,
      seedOnly: eventTacticData?.seedOnly ? eventTacticData?.seedOnly : '',
      deletedIds: [0],
      event: eventTacticData?.event ? eventTacticData?.event : '',
      isDraft: eventTacticData?.isDraft ? eventTacticData?.isDraft : 'Y',
      actions: eventTacticData?.actions ? eventTacticData?.actions : [],
      name: '',
      ruleGroupId: groupId ? groupId : formulaRuleId,
      triggerOwner: '',
      type: '',
      version: '',
      versionNumber: 0,
      overrideType: 'TRIGGER',
      clientCode: eventTacticData?.clientCode?.length > 0 ? eventTacticData?.clientCode : [],
      lastStep: eventTacticData?.isDraft === 'N' ? eventTacticData?.lastStep : 2,
    };
    dispatch(postEventTactic(passValues));
  };

  useEffect(() => {
    if (errorMsg || successMsg) {
      if (successMsg) {
        activeStep === 1 && setStepSuccessMsg(`${steps[1]} Added/Modified Successfully`);
      }
      setTimeout(() => {
        dispatch(resetMessage());
        setStepSuccessMsg('');
      }, 1000);
    }
  }, [errorMsg, successMsg]);

  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  useEffect(() => {
    if (triggerId && eventTacticData?.code) {
      dispatch(fetchEventTactic(triggerId));
    }
  }, [triggerId]);

  useEffect(() => {
    if (addEventTacticStatus === 200 && successMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        if (activeStep === 1 && !saveRef.current) {
          handleNext();
        }
      }, 1000);
    }
  }, [addEventTacticStatus, successMsg]);
  useEffect(() => {
    if (downloadSuccessMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 1000);
    }
  }, [downloadSuccessMsg]);

  useEffect(() => {
    if (ruleGroupId && !ShowFilterData) {
      dispatch(fetchFilterRuleGroup(ruleGroupId));
    }
  }, [ruleGroupId, ShowFilterData, isCopy]);
  useEffect(() => {
    if (eventTacticData?.ruleGroupCode && !ShowFilterData) {
      setRuleGroupCode(ruleGroupCode ? ruleGroupCode : eventTacticData?.ruleGroupCode);
      // setRuleGroupId(eventTacticData?.ruleGroupId);
    }
  }, [eventTacticData?.ruleGroupCode, ShowFilterData]);

  // useEffect(() => {
  //   handleDirty(eventTacticData?.ruleGroupCode !== ruleGroupCode);
  // }, [ruleGroupCode]);

  return ShowFilterData ? (
    <div>
      <div className="new-standard-textfields">
        <Button
          variant="text"
          className={'mb-3 search-btn'}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setShowFilterData(false);
                  },
                }),
              );
            } else {
              setShowFilterData(false);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          Go Back
        </Button>
      </div>
      <div>
        <BreadCrums
          name={'Trigger Name'}
          code={eventTacticData?.code}
          description={'Trigger Description'}
          descriptionValue={eventTacticData?.description}
        />
      </div>
      <AddFilterRuleGroup
        StepperFilter={true}
        fieldListCode={fieldListCode}
        setShowFilterData={setShowFilterData}
        setIsCopy={setIsCopy}
        isCopy={isCopy}
        setRuleGroupCode={setRuleGroupCode}
        setGroupId={setGroupId}
        overrideType={overrideType}
        handleDirty={handleDirty}
      />
    </div>
  ) : (
    <>
      <BreadCrums
        name={'Trigger Name'}
        code={eventTacticData?.code}
        description={'Trigger Description'}
        descriptionValue={eventTacticData?.description}
      />
      {/* <FilterTable
        setShowFilterData={setShowFilterData}
        setRuleGroupId={setRuleGroupId}
        StepperFilter={true}
        fieldListCode={fieldListCode}
        setRuleGroupCode={setRuleGroupCode}
        ruleGroupId={ruleGroupId}
        setIsCopy={setIsCopy}
        ruleGroupCode={ruleGroupCode}
      /> */}
      <FilterTable
        setShowFilterData={setShowFilterData}
        setRuleGroupId={setRuleGroupId}
        StepperFilter={true}
        fieldListCode={fieldListCode}
        setRuleGroupCode={setRuleGroupCode}
        setGroupId={setGroupId}
        ruleGroupId={ruleGroupId}
        setIsCopy={setIsCopy}
        ruleGroupCode={ruleGroupCode}
        handleDirty={handleDirty}
      />
      {ruleGroupId && ruleGroupCode && (
        <>
          <div className={componentClasses.root}>
            <Accordion
              className="accordion-styling"
              elevation={0}
              expanded={expanded}
              onChange={handleChange('panel1')}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className={componentClasses.heading}>Filter Information</Typography>
              </AccordionSummary>
              <AccordionDetails className={componentClasses.detailsCard}>
                <FilterInformationTable ruleGroupId={ruleGroupId} />
              </AccordionDetails>
            </Accordion>
          </div>
          <div>
            <Typography className={`mt-2 ${componentClasses.heading}`}>
              Result Expression :{' '}
              {filterRuleGroupData?.sqlExpression ? filterRuleGroupData?.sqlExpression : ''}
            </Typography>
          </div>{' '}
        </>
      )}
      <div className="new-standard-textfields d-flex justify-content-center mt-2">
        <Button
          variant="outlined"
          onClick={handleBack}
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
        >
          Back
        </Button>
        {/* {eventTacticData?.isDraft === "N" && ( */}
        <Button
          variant="outlined"
          type="submit"
          className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
          disabled={
            !ruleGroupCode ||
            (eventTacticData?.ruleGroupCode && roleDataDisable?.edit === false && rowSelected) ||
            enabledSubmission
          }
          onClick={() => {
            handleSubmit();
            saveRef.current = true;
            handleDirty(false, 'fixed');
          }}
        >
          Save
        </Button>
        {/* )} */}
        <Button
          variant="outlined"
          onClick={() => {
            saveRef.current = false;
            handleSubmit();
          }}
          disabled={
            !ruleGroupCode ||
            (eventTacticData?.ruleGroupCode && roleDataDisable?.edit === false && rowSelected) ||
            enabledSubmission
          }
          className={`search-btn ml-1 ${classes.buttonRoot}`}
        >
          Save & Next
        </Button>
      </div>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(stepSuccessMsg || downloadSuccessMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={stepSuccessMsg || downloadSuccessMsg || printUsageSuccessMsg}
        />
      )}
    </>
  );
};

export default StepperFilter;
